import { Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import NetwalaModal from "../Items/Modal/Index";
import NetwalaMultiSelect from "../Items/Select/MultiSelect";
import "./styles/RequestIPTVModal.css";

interface AssignAreasToStaffModalProp {
  show: boolean;
  handleClose: (reload?: boolean) => void;
  staffId: number;
  assignedAreas?: Area[];
}

const AssignAreasToStaffModal: React.FC<AssignAreasToStaffModalProp> = ({
  show,
  handleClose,
  staffId,
  assignedAreas = [],
}) => {
  const [form] = Form.useForm();

  const { openNotification, contextHolder } = useMultiNotification();
  const [selectedAreas, setSelectedAreas] = useState<(string | number)[]>([]);
  const [availableAreas, setAvailableAreas] = useState<NetwalaSelectOptions[]>([]);
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<any>("areas/AssignAreaToStaff", true);

  const [
    getAreasApi,
    areasApiResponse,
    areasApiError,
    areasApiLoading,
    areasApiMessage,
    areasApiErrorCount,
  ] = useAxiosPost<ResponseProp>("areas/getAreasByOwner");

  useEffect(() => {
    if (show) {
      getAreasApi({});
      form.resetFields();
      setSelectedAreas([]);
    }
  }, [show]);

  useEffect(() => {
    if (areasApiResponse !== null) {
      const data: any = areasApiResponse.responseData;
      
      // Get assigned area IDs
      const assignedAreaIds = assignedAreas.map((area) => area.intPkAreaID);
      
      // Filter out already assigned areas
      const filteredAreas = data
        .filter((item: Area) => !assignedAreaIds.includes(item.intPkAreaID))
        .map((item: Area): NetwalaSelectOptions => {
          return {
            value: item.intPkAreaID,
            label: item.areaName,
          };
        });

      setAvailableAreas(filteredAreas);
    }
  }, [areasApiResponse, assignedAreas]);

  const onFinish = (values: any) => {
    const { areas } = values;
    if (!areas || areas.length === 0) {
      openNotification("error", "Error", "Please select at least one area");
      return;
    }
    const dataToSend = {
      areaIds: areas,
      staffId: staffId,
    };
    postApiData(dataToSend);
  };

  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);

  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);

  const onFinishFailed = (errorInfo: any) => {};

  return (
    <>
      <NetwalaModal
        title="Assign Areas to Staff"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          handleClose(false);
        }}
      >
        {contextHolder}
        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              form={form}
              name="assignAreasForm"
            >
              <Form.Item
                label={<span className="create-user-form-label">Areas</span>}
                name="areas"
                rules={[
                  { required: true, message: "Please select at least one area!" },
                ]}
              >
                <NetwalaMultiSelect
                  showSearch={true}
                  value={selectedAreas}
                  onChange={(value) => {
                    setSelectedAreas(value);
                    form.setFieldsValue({ areas: value });
                  }}
                  height="45px"
                  options={availableAreas}
                  placeHolder="Select areas"
                />
              </Form.Item>

              <Form.Item>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <NetwalaButton
                    backgroundColor={ButtonProps.background.SECONDARY}
                    height={ButtonProps.height.STANDARD}
                    width="120px"
                    textColor={ButtonProps.color.BLACK}
                    onClick={() => handleClose(false)}
                    text="Cancel"
                    disabled={apiLoading}
                  />
                  <NetwalaButton
                    backgroundColor={ButtonProps.background.YELLOW}
                    height={ButtonProps.height.STANDARD}
                    width="120px"
                    textColor={ButtonProps.color.STANDARD}
                    onClick={() => {}}
                    htmlType="submit"
                    text="Assign Areas"
                    borderColor="#FFA726"
                    disabled={apiLoading}
                  />
                </div>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default AssignAreasToStaffModal;

